import type { IconSvgObject } from './types';

const StrokeOutsideIcon: IconSvgObject = [
  ["path", { d: "M18.1111 14.2222L21 14.2222C21.5523 14.2222 22 14.6699 22 15.2222V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V3C2 2.44772 2.44772 2 3 2L8.77778 2C9.33006 2 9.77778 2.44772 9.77778 3V5.88889", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default StrokeOutsideIcon;
